// --- 全局功能代码 (来自 theme-documents.js) ---
(function delayImageSetup() {
  'use strict';
  const images = document.getElementsByClassName('custom-content-image');
  for (let i = 0; i < images.length; i++) {
    if (images[i] instanceof HTMLImageElement || images[i] instanceof HTMLPictureElement) {
      images[i].loading = "lazy";
    }
  }
})();

(function disableModuleFeatures() {
  'use strict';

  function disableKeyboardShortcuts(event) {
    if (event.key === 'F12') {
      event.preventDefault();
    } else if (event.ctrlKey && event.shiftKey && (event.key === 'I' || event.key === 'i')) {
      event.preventDefault();
    } else if (event.shiftKey && event.key === 'F10') {
      event.preventDefault();
    }
  }

  function isEditableElement(element) {
    if (!element || typeof element.tagName !== 'string') {
      return false;
    }
    const tagName = element.tagName.toUpperCase();
    const type = element.type ? element.type.toLowerCase() : '';
    return (tagName === 'INPUT' && type === 'text') || tagName === 'TEXTAREA';
  }

  function handleClipboardEvent(event) {
    if (!isEditableElement(event.target)) {
      event.preventDefault();
    }
  }

  document.addEventListener('keydown', disableKeyboardShortcuts);
  document.addEventListener('cut', handleClipboardEvent);
  document.addEventListener('paste', handleClipboardEvent);

  // 可选：完全屏蔽右键上下文菜单
  // document.addEventListener('contextmenu', function(event) {
  //   if (!isEditableElement(event.target)) {
  //      event.preventDefault();
  //   }
  // });
})();
